// Assests
import { ReactComponent as Asort } from "../../Assets/Images/asort.svg";

const SortButton = ({ sortObj, sortHandler, name }) => {
  const handleToggle = () => {
    const newSortOrder =
      sortObj?.sortBy === name && sortObj?.sortOrder === 1 ? -1 : 1;
    sortHandler({
      sortBy: name,
      sortOrder: newSortOrder,
    });
  };

  return (
    <div className="sort" onClick={handleToggle}>
      <Asort className="sortIcon" />
    </div>
  );
};

export default SortButton;
